import styled from "styled-components";


export const ProjectsContent = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;    
`

export const StyledProjectsSection = styled.section`
    display: flex;
    flex-direction: column;
    padding-top: 6rem;

    h1{
        font-size: 3rem;
        color: var(--dark--primary--text);
        text-align: center;
        margin-bottom: 2rem;
    }

    .icon{
        color: var(--dark--green--50);
    }
`